import { createContext, useCallback, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Footer } from "../components/Footer";
import { EditNav } from "../navs/EditNav";
import { TournamentNav } from "../navs/TournamentNav";

export const TournamentScrollContext = createContext<
  { scrollToTop: () => void } | undefined
>(undefined);

export const TournamentContainer = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const tournamentPaths = ["/tournaments", "/tournaments/", "/tournaments/new"];

  const mainContentRef = useRef<HTMLDivElement | null>(null);

  const scrollToTop = useCallback(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, []);

  return (
    <TournamentScrollContext.Provider value={{ scrollToTop }}>
      <div className="navContentContainer">
        <nav className="blueNavBar">
          {tournamentPaths.includes(currentPath) ? (
            <TournamentNav />
          ) : (
            <EditNav />
          )}
        </nav>
        <div className="mainContent" ref={mainContentRef}>
          <div className="container">
            <Outlet></Outlet>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </TournamentScrollContext.Provider>
  );
};
